import React, { Suspense, useContext } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Layout } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { IRoute } from 'interfaces';
import AppBreadcrumb from 'containers/AppLayout/AppBreadcrumb';
import BrowserPermissionModal from 'components/shared/BrowserPermissionModal';
import { NetworkContext } from 'contexts/network';
import { StoreContext } from 'contexts';
import { flagConstants } from 'constants/index';

const { Content } = Layout;
const { FLAG_KEYS } = flagConstants;

interface AppContentProps {
  filteredRoutes: IRoute[];
}

const AppContent: React.FC<AppContentProps> = props => {
  const { filteredRoutes } = props;
  const { isOnlineMode } = useContext(NetworkContext);
  const { extraConfig, featureFlagsData } = useContext(StoreContext);
  const canShowBrowserPermissionModal = !!extraConfig?.enableEpicOmni1318;
  const enableAllowShowNotificationBrowser =
    featureFlagsData[FLAG_KEYS.SHOW_NOTIFICATION_BROWSER]?.enabled;

  return (
    <Content className="app-content">
      <AppBreadcrumb />
      <Suspense fallback={null}>
        <Switch>
          {filteredRoutes.map(
            ({
              component: Component,
              iFrameSrc,
              name,
              hideBackButton,
              isUseMobileView,
              isNotUseMobileViewWhenEnabledFlagKey,
              browserPermissions,
              hideBreadcrumbMobileView,
              allowShowNotificationBrowser,
              ...rest
            }) => {
              if (!Component) return null;
              const allowShowNotification =
                allowShowNotificationBrowser &&
                enableAllowShowNotificationBrowser;

              return (
                <Route
                  {...rest}
                  key={uuidv4()}
                  render={routeProps => (
                    <>
                      <Component
                        {...routeProps}
                        iFrameSrc={iFrameSrc}
                        filteredRoutes={filteredRoutes}
                        hideBackButton={hideBackButton}
                        isUseMobileView={isUseMobileView}
                        hideBreadcrumbMobileView={hideBreadcrumbMobileView}
                        isNotUseMobileViewWhenEnabledFlagKey={
                          isNotUseMobileViewWhenEnabledFlagKey
                        }
                        allowShowNotificationBrowser={allowShowNotification}
                      />
                      {isOnlineMode &&
                        Array.isArray(browserPermissions) &&
                        (canShowBrowserPermissionModal ||
                          allowShowNotification) && (
                          <BrowserPermissionModal
                            browserPermissions={browserPermissions}
                            allowShowNotificationBrowser={allowShowNotification}
                          />
                        )}
                    </>
                  )}
                />
              );
            }
          )}
          {/* TODO: remove this menu-tracking redirect after 6 months (end of 2023) */}
          <Redirect from="/menu-tracking" to="/menu-directory" />
          <Redirect from="/" to="/404" />
        </Switch>
      </Suspense>
    </Content>
  );
};

export default AppContent;
